import React, { createContext, useContext, useEffect, useState } from "react";

const LANGUAGE_KEY = "rarium_language";
const LanguageContext = createContext(null);

const englishTranslations = {
  Aste: "Auctions",
  Asta: "Auction",
  Categorie: "Categories",
  Vendi: "Sell",
  Blog: "Journal",
  Profilo: "Profile",
  Esci: "Log out",
  Accedi: "Log in",
  Registrati: "Sign up",
  Lingua: "Language",
  Menu: "Menu",
  "Il tuo account": "Your account",
  "Lotto in copertina — N° 001": "Featured lot — No. 001",
  "Aste online curate.": "Curated online auctions.",
  Rarità: "Rare finds",
  " che meritano un pubblico.": " deserve the right audience.",
  "Rarium è la casa d'aste online in Italia per collezionisti esigenti — aste di orologi, arte, gioielli, auto classiche, vini, monete e libri rari verificati da esperti indipendenti.": "Rarium is an online auction house for discerning collectors, featuring watches, art, jewellery, classic cars, wine, coins and rare books vetted by independent experts.",
  "Esplora le aste": "Explore auctions",
  "Vendi con noi": "Sell with us",
  Collezionisti: "Collectors",
  "Esperti verificati": "Verified experts",
  "Rating collezionisti": "Collector rating",
  "Cosa cerchi oggi?": "What are you looking for?",
  "Vedi tutte →": "View all →",
  "Selezione della settimana": "This week's selection",
  "Lotti in evidenza": "Featured lots",
  "Tutte le aste →": "All auctions →",
  "Il metodo Rarium": "The Rarium approach",
  "Tre passaggi. Zero approssimazioni.": "Three steps. No guesswork.",
  "Ogni oggetto arriva al mercato solo dopo essere passato dalle mani di un esperto della sua categoria.": "Every item reaches the market only after review by an expert in its category.",
  Consegna: "Submit",
  "Carica foto e provenienza. Il nostro esperto risponde in 48 ore.": "Upload photos and provenance. Our specialist will respond within 48 hours.",
  Verifica: "Verification",
  "Autenticazione, stima e catalogo editoriale a cura di specialisti indipendenti.": "Authentication, valuation and an editorial catalogue prepared by independent specialists.",
  "Sette giorni di battaglia tra collezionisti. Trasparente, veloce, misurabile.": "Seven days of bidding among collectors. Transparent, fast and clear.",
  "Chi siamo": "About us",
  "Aste online curate in Italia.": "Curated online auctions.",
  "Domande frequenti": "Frequently asked questions",
  "Tutto quello che devi sapere sulle nostre aste.": "Everything you need to know about our auctions.",
  "Come funzionano le aste online su Rarium?": "How do Rarium online auctions work?",
  "Le aste durano tipicamente 7 giorni. Ogni lotto viene autenticato dai nostri esperti, presentato con foto, descrizione editoriale e stima di mercato. Gli utenti registrati possono fare offerte in tempo reale: l'offerta più alta al termine dell'asta si aggiudica il lotto.": "Auctions typically run for 7 days. Our experts authenticate every lot, which is presented with photos, an editorial description and a market estimate. Registered users can bid in real time; the highest bid at the end wins the lot.",
  "Quali categorie di aste posso trovare?": "Which auction categories can I browse?",
  "Sette categorie curate: Arte & Antiquariato, Orologi vintage, Gioielli, Auto Classiche, Vini pregiati, Monete antiche e Libri Rari. Ogni categoria è supervisionata da un esperto indipendente.": "Seven curated categories: art and antiques, vintage watches, jewellery, classic cars, fine wine, ancient coins and rare books. Each category is overseen by an independent expert.",
  "Quanto costa partecipare a un'asta?": "How much does it cost to take part in an auction?",
  "La registrazione e la partecipazione alle aste sono gratuite. L'acquirente paga solo il prezzo di aggiudicazione. Rarium trattiene una commissione del 10% dal venditore sull'importo di aggiudicazione.": "Registration and bidding are free. Buyers pay only the winning bid. Rarium charges the seller a 10% commission on the final price.",
  "Come vendo un oggetto tramite le aste Rarium?": "How do I sell an item through Rarium?",
  "Registrati gratuitamente, carica una foto del tuo oggetto: la nostra AI genera automaticamente titolo, descrizione e stima di mercato. Dopo la verifica del curatore, il lotto viene pubblicato all'asta per 7 giorni.": "Register for free and upload a photo of your item. Our AI generates a title, description and market estimate. Once approved by a curator, the lot is listed for 7 days.",
  "I lotti in asta sono autenticati?": "Are auction lots authenticated?",
  "Sì. Ogni lotto viene esaminato e autenticato da esperti indipendenti prima di essere presentato all'asta. Autenticazione, provenienza e condizioni sono documentate nella scheda del lotto.": "Yes. Independent experts inspect and authenticate every lot before it is listed. Authentication, provenance and condition are documented on the lot page.",
  "Perché Rarium": "Why Rarium",
  "Un mercato costruito per la fiducia.": "A marketplace built on trust.",
  "Autenticazione indipendente per ogni lotto.": "Independent authentication for every lot.",
  "Pagamenti protetti tramite Stripe, escrow disponibile.": "Secure payments through Stripe, with escrow available.",
  "Spedizioni assicurate porta a porta, tracciate in tempo reale.": "Insured, door-to-door shipping with real-time tracking.",
  "La lista dei curatori.": "The Curators' List.",
  "Un'email settimanale con i lotti più interessanti selezionati dai nostri esperti.": "A weekly email featuring the most interesting lots selected by our experts.",
  "La tua email": "Your email",
  Iscrivimi: "Subscribe",
  "Aste Live": "Live auctions",
  "Tutte le aste": "All auctions",
  "Tutte le categorie": "All categories",
  "Termina prima": "Ending soon",
  "Più recenti": "Newest",
  "Prezzo: alto→basso": "Price: high to low",
  "Prezzo: basso→alto": "Price: low to high",
  "Caricamento…": "Loading…",
  "Nessun lotto disponibile per questa categoria.": "No lots are available in this category.",
  "Il catalogo": "The catalogue",
  "Sette specializzazioni.": "Seven specialisms.",
  "Ogni categoria è affidata a un curatore indipendente con oltre 10 anni di esperienza sul mercato di riferimento.": "Each category is led by an independent curator with more than 10 years of experience in its market.",
  "Categoria ": "Category ",
  "Vedi i lotti →": "View lots →",
  Manifesto: "Manifesto",
  "Il metodo ": "The ",
  "Crediamo che gli oggetti rari non abbiano bisogno di essere venduti. Hanno bisogno di essere ": "We believe rare objects do not need to be sold. They need to be ",
  "capiti": "understood",
  ", raccontati, e messi davanti alle persone giuste.": ", given a story, and placed before the right people.",
  "Rarium è nata a Milano nel 2026 da un gruppo di curatori, orologiai, sommelier e restauratori che condividevano una stessa frustrazione: le case d'asta tradizionali sono lente, le piattaforme online sono superficiali.": "Rarium was founded in Milan in 2026 by a group of curators, watchmakers, sommeliers and restorers who shared one frustration: traditional auction houses move slowly, while online platforms lack depth.",
  "Abbiamo costruito qualcosa di diverso — una piattaforma che unisce la ": "We built something different: a platform that brings together the ",
  "disciplina editoriale": "editorial discipline",
  " di una casa d'asta storica alla ": " of a historic auction house with the ",
  velocità: "speed",
  " del digitale, con la ": " of digital services and the ",
  trasparenza: "transparency",
  " radicale di internet.": " of the internet.",
  "Categorie curate": "Curated categories",
  "Esperti indipendenti": "Independent experts",
  "Metti in asta il tuo pezzo →": "List your item →",
  "Aste curate per collezionisti esigenti. Ogni oggetto è verificato dai nostri esperti prima di essere presentato al mercato.": "Curated auctions for discerning collectors. Every item is reviewed by our experts before reaching the market.",
  "Commissione venditore: ": "Seller commission: ",
  " sul prezzo di aggiudicazione. Nessun costo se il lotto non viene venduto.": " of the winning bid. No fee if your lot does not sell.",
  Marketplace: "Marketplace",
  "Il nostro metodo": "Our approach",
  Company: "Company",
  Esperti: "Experts",
  Stampa: "Press",
  Contatti: "Contact",
  Privacy: "Privacy",
  Termini: "Terms",
  Cookie: "Cookies",
  "La tua privacy, le tue scelte": "Your privacy, your choice",
  "Usiamo cookie tecnici necessari al funzionamento del sito. Con il tuo consenso possiamo attivare cookie di analisi e marketing; puoi modificarlo in qualsiasi momento.": "We use essential cookies to keep this site working. With your consent, we may also use analytics and marketing cookies. You can change your choice at any time.",
  "Necessari, sempre attivi": "Essential, always active",
  Analisi: "Analytics",
  Marketing: "Marketing",
  "Solo necessari": "Essential only",
  "Rifiuta opzionali": "Reject optional",
  "Personalizza": "Customise",
  "Salva preferenze": "Save preferences",
  "Accetta tutti": "Accept all",
  "Preferenze cookie": "Cookie preferences",
  "featured auction": "Featured auction",
  "Aggiudicato": "Sold",
  "Offerta attuale": "Current bid",
  Termina: "Ends",
  Terminata: "Ended",
  Bentornato: "Welcome back",
  "Errore login": "Unable to log in",
  "L'accesso privato ai lotti più rari.": "Private access to the rarest lots.",
  "Bentornato.": "Welcome back.",
  Password: "Password",
  "Password dimenticata?": "Forgot password?",
  "Diventa collezionista Rarium": "Become a Rarium collector",
  "Registrazione gratuita, autenticazione europea.": "Free registration, European authentication.",
  "Crea il tuo account · Step ": "Create your account · Step ",
  " di 2": " of 2",
  "Unisciti alla lista.": "Join the list.",
  "Ultimi dettagli.": "Almost there.",
  "Nome e cognome": "Full name",
  "Password (min. 8 caratteri)": "Password (at least 8 characters)",
  Continua: "Continue",
  "Ti serviranno anche IBAN, codice fiscale e indirizzo di residenza per completare la registrazione. Questi dati sono richiesti per il pagamento dei venditori e la conformità fiscale italiana.": "You will also need your IBAN, tax number and residential address to complete registration. These details are required for seller payouts and Italian tax compliance.",
  "IBAN (per accrediti come venditore)": "IBAN (for seller payouts)",
  "Codice Fiscale o Partita IVA": "Tax code or VAT number",
  "Indirizzo (via e numero)": "Street address",
  Città: "City",
  CAP: "Postcode",
  "Telefono (opzionale)": "Phone (optional)",
  Indietro: "Back",
  "Crea account": "Create account",
  "Ti invieremo una email di conferma. Puoi navigare le aste da subito, ma per pubblicare lotti l'email deve essere verificata.": "We will send you a confirmation email. You can browse auctions right away, but you must verify your email address before listing lots.",
  "Hai già un account?": "Already have an account?",
  "Errore registrazione": "Unable to register",
  "IBAN non valido (deve iniziare con 2 lettere di codice paese)": "Invalid IBAN (it must start with a two-letter country code)",
  "Codice fiscale/P.IVA non valido": "Invalid tax code/VAT number",
  "CAP non valido": "Invalid postcode",
  "Account creato. Controlla la tua email per confermare l'indirizzo.": "Account created. Check your email to confirm your address.",
  "Account creato. La verifica email sarà attiva a breve.": "Account created. Email verification will be available shortly.",
  "Controlla la tua email": "Check your email",
  "Ti abbiamo scritto.": "We've sent you an email.",
  "Se ": "If ",
  " è registrata su Rarium, entro pochi minuti riceverai un'email con il link per reimpostare la password.": " is registered with Rarium, you will receive an email with a password reset link in a few minutes.",
  "Torna al login": "Back to log in",
  "Recupero accesso": "Account recovery",
  "Inserisci la tua email e ti manderemo un link per reimpostarla.": "Enter your email and we will send you a reset link.",
  "Invia link di recupero": "Send reset link",
  "Ti sei ricordato?": "Remembered your password?",
  "Errore. Riprova più tardi.": "Something went wrong. Try again later.",
  "Nuova password.": "New password.",
  "Scegli una password forte di almeno 8 caratteri.": "Choose a strong password with at least 8 characters.",
  "Nuova password": "New password",
  "Conferma password": "Confirm password",
  "Reimposta password": "Reset password",
  "La password deve avere almeno 8 caratteri": "Your password must be at least 8 characters",
  "Le password non coincidono": "Passwords do not match",
  "Password reimpostata. Accedi con la nuova password.": "Password reset. Log in with your new password.",
  "Torna al dashboard": "Back to dashboard",
  "Conferma email": "Confirm email",
  "Token mancante": "Missing token",
  "Email già verificata.": "Email already verified.",
  "Email ": "Email ",
  " confermata.": " confirmed.",
  "Token non valido o scaduto": "Invalid or expired token",
  "Verifica in corso…": "Verifying…",
  "Stiamo controllando il tuo link.": "We are checking your link.",
  "Verifica completata": "Verification complete",
  "Benvenuto ufficiale su Rarium.": "Welcome to Rarium.",
  "Vai al dashboard": "Go to your dashboard",
  "Link non valido.": "Invalid link.",
  ". Puoi richiedere un nuovo link dal tuo dashboard.": ". You can request a new link from your dashboard.",
  "Esplora aste": "Browse auctions",
  "Pagamento annullato.": "Payment cancelled.",
  "Nessun addebito è stato effettuato. Puoi riprovare in qualsiasi momento dal dashboard.": "You have not been charged. You can try again at any time from your dashboard.",
  Grazie: "Thank you",
  "Pagamento ricevuto.": "Payment received.",
  "Abbiamo confermato il tuo pagamento di ": "We have confirmed your payment of ",
  ". Ti abbiamo inviato una email con i dettagli di spedizione.": ". We have emailed you the shipping details.",
  "Stiamo confermando il pagamento con Stripe… attendi qualche istante.": "We are confirming your payment with Stripe… please wait a moment.",
  "Altri lotti": "More lots",
  "Impostazioni account": "Account settings",
  "Il mio profilo.": "My profile.",
  "Dati personali e fatturazione": "Personal and billing details",
  "Codice Fiscale / P.IVA": "Tax code / VAT number",
  Telefono: "Phone",
  "Salva modifiche": "Save changes",
  "Cambia password": "Change password",
  "Password attuale": "Current password",
  "Nuova password (min. 8)": "New password (at least 8 characters)",
  "Conferma nuova password": "Confirm new password",
  "Aggiorna password": "Update password",
  "Email account: ": "Account email: ",
  " — non modificabile dal profilo per motivi di sicurezza.": " — cannot be changed here for security reasons.",
  "Profilo aggiornato": "Profile updated",
  "Password modificata": "Password changed",
  "La nuova password deve avere almeno 8 caratteri": "Your new password must be at least 8 characters",
  "Il tuo studio.": "Your dashboard.",
  "Email non verificata": "Email not verified",
  "Verifica il tuo indirizzo ": "Verify your address ",
  " per pubblicare lotti in asta.": " to list lots for auction.",
  "Reinvia email": "Resend email",
  "Invio…": "Sending…",
  "Email di verifica inviata. Controlla la tua casella.": "Verification email sent. Check your inbox.",
  "Sistema email in configurazione. Riprova più tardi.": "The email system is being configured. Try again later.",
  "Errore invio email": "Unable to send email",
  "Metti in asta": "List an item",
  "Le mie offerte (": "My bids (",
  ")": ")",
  "I miei lotti (": "My lots (",
  "Preferiti (": "Watchlist (",
  "Non hai ancora salvato lotti.": "You have not saved any lots yet.",
  "Nessuna offerta ancora.": "No bids yet.",
  "Non hai ancora messo in asta nulla.": "You have not listed any lots yet.",
  "Metti in asta ora": "List an item now",
  "La tua offerta": "Your bid",
  Stato: "Status",
  "Sei in testa": "You are the highest bidder",
  Superato: "Outbid",
  " offerte": " bids",
  "Se aggiudicato: ": "If sold: ",
  " a te · ": " to you · ",
  " commissione Rarium": " Rarium commission",
  "Il blog delle aste.": "The auction journal.",
  "Guide, consigli e storie del collezionismo — a cura del team editoriale Rarium. Un nuovo articolo ogni settimana.": "Guides, advice and stories from the world of collecting, curated by the Rarium editorial team. A new article every week.",
  Editoriale: "Journal",
  "Prossimo articolo in arrivo.": "Next article coming soon.",
  "Il nostro editore pubblica un nuovo articolo ogni settimana. Torna presto o iscriviti alla newsletter.": "Our editor publishes a new article every week. Check back soon or subscribe to the newsletter.",
  "← Tutti gli articoli": "← All articles",
  "Vendi con Rarium": "Sell with Rarium",
  "Metti in asta il tuo pezzo.": "List your item for auction.",
  "La nostra AI ti aiuta a scrivere una scheda editoriale e a stimare il valore in secondi. Approva, modifica e pubblica.": "Our AI helps write an editorial listing and estimate value in seconds. Review, edit and publish.",
  "Commissione Rarium": "Rarium commission",
  "Rarium trattiene il ": "Rarium charges ",
  " sul prezzo di aggiudicazione.": " of the winning bid.",
  "Foto principale": "Main photo",
  "Clicca per caricare": "Click to upload",
  "Analisi in corso…": "Analysing…",
  "Genera scheda con AI": "Generate listing with AI",
  "Oppure URL immagine": "Or image URL",
  Titolo: "Title",
  Descrizione: "Description",
  Categoria: "Category",
  "Seleziona…": "Select…",
  Condizioni: "Condition",
  Eccellente: "Excellent",
  Ottimo: "Very good",
  Buono: "Good",
  Discreto: "Fair",
  "Base d'asta (€)": "Starting bid (€)",
  "Stima min (€)": "Low estimate (€)",
  "Stima max (€)": "High estimate (€)",
  Provenienza: "Provenance",
  "Durata asta (ore)": "Auction duration (hours)",
  "Spese di spedizione": "Shipping costs",
  "Costo (€)": "Cost (€)",
  "Note (facoltative)": "Notes (optional)",
  "Metti 0 se la spedizione è inclusa nel prezzo. Il costo viene sommato all'aggiudicazione al checkout.": "Enter 0 if shipping is included. Otherwise, the cost will be added at checkout.",
  "Galleria foto aggiuntive": "Additional photos",
  "+ Aggiungi": "+ Add",
  "Inserisci URL di foto aggiuntive (dettagli, retro, imperfezioni, certificati). Aiutano gli offerenti a valutare meglio il lotto.": "Add URLs for extra photos (details, reverse, flaws, certificates). These help bidders assess the lot.",
  Rimuovi: "Remove",
  "Pubblica il lotto": "Publish lot",
  "Tu ricevi (netti)": "You receive (net)",
  "Carica prima una foto": "Upload a photo first",
  "Scheda generata dall'AI": "Listing generated by AI",
  "AI non disponibile": "AI unavailable",
  "Serve una URL immagine o carica una foto (per demo inserisci URL)": "Add an image URL or upload a photo (for the demo, enter a URL)",
  "Devi accettare la commissione del ": "You must accept the ",
  "% per pubblicare": "% commission to publish",
  "Lotto pubblicato": "Lot published",
  "Offerta piazzata!": "Bid placed!",
  "Fai offerta": "Place bid",
  "Termina tra": "Time remaining",
  "Lotto aggiudicato": "Lot sold",
  "Questo lotto è stato aggiudicato.": "This lot has been sold.",
  "Attendere…": "Please wait…",
  "La tua offerta (min. ": "Your bid (min. ",
  "Accedi per fare un'offerta. ": "Log in to place a bid. ",
  Autenticato: "Authenticated",
  Curato: "Curated",
  "Spedizione assicurata": "Insured shipping",
  Specifiche: "Specifications",
  Venditore: "Seller",
  Spedizione: "Shipping",
  "Aggiunti al totale al checkout": "Added to the total at checkout",
  Inclusa: "Included",
  "Nessun costo aggiuntivo per l'acquirente": "No additional cost to the buyer",
  "Storia delle offerte": "Bid history",
  "Ancora nessuna offerta. Sii il primo.": "No bids yet. Be the first.",
  "Nota del curatore": "Curator's note",
  "Rimosso dai preferiti": "Removed from watchlist",
  "Aggiunto ai preferiti": "Added to watchlist",
  "Aggiungi ai preferiti": "Add to watchlist",
  "Rimuovi dai preferiti": "Remove from watchlist",
  "Nei preferiti": "In watchlist",
  "Errore": "Error",
  "Ciao, ": "Hello, ",
  Base: "Starting bid",
  "Stima:": "Estimate:",
  "Trattenuta Rarium — ": "Rarium commission — ",
  "Calcolata sull'offerta attuale": "Based on the current bid",
  "Prezzo di aggiudicazione (offerta attuale)": "Winning bid (current bid)",
  "Netto al venditore": "Seller net",
  "L'acquirente paga il prezzo di aggiudicazione per intero. Rarium trattiene il ": "The buyer pays the full winning bid. Rarium charges ",
  "% come commissione di servizio (autenticazione, marketing, pagamenti). Il venditore riceve il netto tramite bonifico entro 5 giorni lavorativi dalla conferma del pagamento.": "% as a service fee (authentication, marketing and payments). The seller receives the net amount by bank transfer within 5 business days of payment confirmation.",
  "Paga ": "Pay ",
  "Accetto che ": "I agree that ",
  "Rarium tratterrà il ": "Rarium will charge ",
  " sul prezzo di aggiudicazione come commissione di servizio. Confermo di essere proprietario dell'oggetto e ne garantisco l'autenticità e la provenienza.": " of the winning bid as a service fee. I confirm that I own this item and guarantee its authenticity and provenance.",
  "Se il tuo lotto viene aggiudicato a ": "If your lot sells for ",
  ", Rarium trattiene ": ", Rarium keeps ",
  " e tu ricevi ": " and you receive ",
  " netti tramite bonifico entro 5 giorni lavorativi dalla conferma del pagamento. La commissione copre autenticazione, marketing, gestione pagamenti e assistenza clienti. Nessun costo se il lotto non viene aggiudicato.": " net by bank transfer within 5 business days of payment confirmation. The fee covers authentication, marketing, payment processing and customer support. There is no fee if your lot does not sell.",
  "Es. Spedizione assicurata corriere espresso, Italia": "E.g. insured express courier, Italy",
  "Se aggiudicato a base d'asta (": "If sold at the starting bid (",
  "Accetto che": "I agree that",
  "Rarium è una casa d'aste digitale specializzata in aste online curate per collezionisti italiani ed europei. Ogni settimana pubblichiamo nuove aste in sette categorie: aste di orologi vintage, aste d'arte e antiquariato, aste di gioielli, aste di auto classiche, aste di vini pregiati, aste di monete antiche e aste di libri rari.": "Rarium is a digital auction house specialising in curated online auctions for collectors across Italy and Europe. Every week we publish auctions across seven categories: vintage watches, art and antiques, jewellery, classic cars, fine wine, ancient coins and rare books.",
  "A differenza delle grandi piattaforme generaliste, ogni asta Rarium è supervisionata da un curatore indipendente esperto della categoria. Autenticiamo la provenienza, verifichiamo le condizioni e scriviamo la scheda editoriale prima di pubblicare il lotto. Il risultato: aste online più trasparenti, con offerte reali di collezionisti veri.": "Unlike large general-purpose platforms, every Rarium auction is overseen by an independent curator who specialises in its category. We authenticate provenance, verify condition and prepare an editorial listing before a lot is published. The result is a more transparent auction experience, with genuine bids from real collectors.",
  "Vuoi partecipare a un'asta? La ": "Want to bid? ",
  "registrazione è gratuita": "registration is free",
  " e le offerte non prevedono commissioni per l'acquirente. Vuoi vendere? ": " and buyers pay no bidding fees. Want to sell? ",
  "Metti in asta il tuo oggetto": "List your item",
  " — trattenimento del 10% solo se il lotto viene aggiudicato.": " — a 10% seller fee applies only if your lot sells.",
  "Rarium: aste online curate in Italia per collezionisti. Aste di orologi vintage, arte, gioielli, auto classiche, vini pregiati, monete antiche e libri rari. Ogni lotto autenticato dai nostri esperti indipendenti.": "Rarium: curated online auctions for collectors. Vintage watches, art, jewellery, classic cars, fine wine, ancient coins and rare books, authenticated by independent experts.",
  "Esplora le aste →": "Explore auctions →",
  "Aste Online Curate — Orologi, Arte, Gioielli, Auto Classiche": "Curated Online Auctions — Watches, Art, Jewellery, Classic Cars",
  "Categorie Aste — 7 Specializzazioni Curate": "Auction Categories — 7 Curated Specialisms",
  "Blog Rarium — Guide alle Aste e al Collezionismo": "Rarium Journal — Auction and Collecting Guides",
  "La disciplina editoriale di una casa d'asta storica, la velocità del digitale. Scopri come i nostri curatori indipendenti autenticano e presentano ogni oggetto.": "The editorial discipline of a historic auction house, with the speed of digital. Discover how our independent curators authenticate and present every item.",
  "Pubblicato": "Published",
  Bozza: "Draft",
  "Pannello amministrativo": "Admin panel",
  "Pannello di amministrazione Rarium": "Rarium administration panel",
  "Loggato come ": "Logged in as ",
  Utenti: "Users",
  "Utenti totali": "Total users",
  "Aste totali": "Total auctions",
  "Aste live": "Live auctions",
  Aggiudicate: "Sold",
  "Offerte piazzate": "Bids placed",
  "GMV (aggiudicato)": "GMV (sold)",
  Commissioni: "Commissions",
  "Fee marketplace": "Marketplace fee",
  "Cerca per email o nome…": "Search by email or name…",
  utenti: "users",
  "Nuovo utente": "New user",
  Utente: "User",
  Ruolo: "Role",
  Offerte: "Bids",
  Lotti: "Lots",
  Registrato: "Joined",
  Azioni: "Actions",
  Modifica: "Edit",
  "Rimuovi admin": "Remove admin",
  "Rendi admin": "Make admin",
  Elimina: "Delete",
  "Nessun utente": "No users found",
  "Tutti gli stati": "All statuses",
  Sospese: "Suspended",
  Terminate: "Ended",
  Lotto: "Lot",
  "Cat.": "Category",
  "Offerta att.": "Current bid",
  Apri: "Open",
  Sospendi: "Suspend",
  Riattiva: "Resume",
  "Nessuna asta": "No auctions found",
  articoli: "articles",
  "Genero…": "Generating…",
  "✨ Genera con AI": "✨ Generate with AI",
  Data: "Date",
  Nascondi: "Hide",
  Pubblica: "Publish",
  "Nessun articolo. Clicca \"Genera con AI\" per crearne uno.": "No articles. Click \"Generate with AI\" to create one.",
  "Come funziona:": "How it works:",
  "Modifica utente": "Edit user",
  Nome: "Name",
  "Password minimo 6 caratteri": "Password must be at least 6 characters",
  "Utente creato": "User created",
  "Utente aggiornato": "User updated",
  "Password (min. 6)": "Password (at least 6 characters)",
  "(min. 6)": "(at least 6)",
  " (lascia vuoto per non cambiare)": " (leave blank to keep unchanged)",
  "Annulla": "Cancel",
  "Crea utente": "Create user",
  "Eliminare l'articolo?": "Delete this article?",
  "Eliminato": "Deleted",
  "Ripristinato in bozza": "Restored to draft",
  "Bozza creata: ": "Draft created: ",
  "Ruolo aggiornato: ": "Role updated: ",
  "Eliminare definitivamente questo utente?": "Permanently delete this user?",
  "Utente eliminato": "User deleted",
  "Asta ": "Auction ",
  "Eliminare definitivamente questa asta e tutte le sue offerte?": "Permanently delete this auction and all its bids?",
  "Asta eliminata": "Auction deleted",
  "L'asta è stata sospesa": "The auction has been suspended",
  "Il generatore AI usa Claude Sonnet 5 per scrivere un articolo di 800-1200 parole sulla categoria con meno articoli pubblicati (rotazione automatica). L'articolo viene salvato in bozza — clicca sul pulsante ▶ per pubblicarlo. In background, uno scheduler settimanale pubblica automaticamente un articolo se sono passati più di 6 giorni dall'ultima pubblicazione.": "The AI generator uses Claude Sonnet 5 to write an 800–1,200 word article for the category with the fewest published posts, rotating automatically. Articles are saved as drafts; click the play button to publish. A weekly scheduler also publishes an article when more than six days have passed since the last one.",
};

function readLanguage() {
  try {
    return window.localStorage.getItem(LANGUAGE_KEY) === "en" ? "en" : "it";
  } catch {
    return "it";
  }
}

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(readLanguage);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  const setLanguage = (nextLanguage) => {
    if (nextLanguage !== "it" && nextLanguage !== "en") return;
    setLanguageState(nextLanguage);
    try {
      window.localStorage.setItem(LANGUAGE_KEY, nextLanguage);
    } catch {
      // The selected language still applies for this visit without storage.
    }
  };

  const translate = (italianText) =>
    language === "en" ? englishTranslations[italianText] || italianText : italianText;

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t: translate }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within LanguageProvider");
  return context;
}